import FJConfig from '../../config/FJConfig';
import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';

import {
    setSliceWarningModalData,
    setSlicePreviewModalData,
    setSliceUpgradeModalData,
    setSliceUploadImageAsPromptModalData,
    setSliceAddAsSceneModalBtuStatus,
    setSliceMobilePreviewData,
    setGlobalLoadingDisplay,
    setMobileSimplePreviewData,
    setSliceIsShowRecordDisplay,
    setAutoSelectionNoticeDisplay,
} from '../slices/FJSliceModals';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJActionCommon from './FJActionCommon.js';
import FJActionRecord from './FJActionRecord.js';
import FJKeymap from '../../util/FJKeymap.js';
export default {
    showWarningModalAction: function (data) {
        return dispatch => {
            dispatch(setSliceWarningModalData({ ...data, display: true }));
        };
    },
    hideWarningModalAction: function () {
        return (dispatch, getState) => {
            const warningModalData = getState().modals.warningModalData;
            dispatch(setSliceWarningModalData({ ...warningModalData, display: false }));
        };
    },
    showPreviewModalDataAction: function (option) {
        return dispatch => {
            if (FJUtil.isMobile()) {
                dispatch(setSliceMobilePreviewData({ ...option, display: true }));
            } else {
                dispatch(setSlicePreviewModalData({ ...option, display: true }));
            }
            FJKeymap.setScope('modal');
        };
    },
    hidePreviewModalDataAction: function () {
        return dispatch => {
            if (FJUtil.isMobile()) {
                dispatch(setSliceMobilePreviewData({ display: false }));
            } else {
                dispatch(setSlicePreviewModalData({ display: false }));
            }
            FJKeymap.setScope('default');
        };
    },
    showUpgradeModalAction: function () {
        return dispatch => {
            if (FJUtil.isMobile()) {
                dispatch(setSliceUpgradeModalData({ display: true }));
            } else {
                // pc端直接弹购买弹窗
                dispatch(FJActionCommon.getCreditsAction());
            }
        };
    },
    hideUpgradeModalAction: function () {
        return dispatch => {
            dispatch(setSliceUpgradeModalData({ display: false }));
        };
    },
    addAsSceneAction: function (id, callback = () => {}) {
        return async (dispatch, getState) => {
            dispatch(setSliceAddAsSceneModalBtuStatus(FJConstant.LOADING));
            callback(FJConstant.LOADING);
            try {
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool make video click', { tool });
                const { historyList, appType } = getState().common;
                const item = historyList.find(item => item.id === id);
                const isVideo =
                    appType === FJAppConstant.AI_VIDEO_GENERATOR || appType === FJAppConstant.VIDEO_REMOVE_BG;
                const isAudioGenerator = FJUtil.isAudioGenerator();
                let blob;
                if (isVideo) {
                    blob = await FJUtil.downloadVideoCacheAvoidance(item.videoUrl);
                    if (!blob) throw new Error('network error');
                    // 视频去背景的资源是webm格式，需要转换为mp4格式
                    if (FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG) {
                        blob = new Blob([blob], { type: 'video/webm' });
                        blob.name = new Date().getTime() + '.webm';
                    } else {
                        blob = new Blob([blob], { type: 'video/mp4' });
                        blob.name = new Date().getTime() + '.mp4';
                    }
                } else if (isAudioGenerator) {
                    blob = await FJUtil.downloadVideoCacheAvoidance(item.audioUrl);
                    blob = new Blob([blob], { type: 'audio/mpeg' });
                    blob.name = FJUtil.getUseFileName(item.audioName, '.mp3');
                } else {
                    blob = await FJUtil.downloadImageCacheAvoidance(item.imgUrl);
                    blob.name = new Date().getTime() + '.png';
                }
                const _jumpUrl = uploadKey => {
                    const url = FJUtil.getCurrentUrl() + 'editor/app?rec_id=' + uploadKey;
                    window.open(url);
                };
                FJUtil.readFiles(
                    [blob],
                    {
                        module: 'media',
                        isAddToPip: appType === FJAppConstant.VIDEO_REMOVE_BG,
                    },
                    _jumpUrl,
                );
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(setSliceAddAsSceneModalBtuStatus(FJConstant.SUCCESS));
                callback(FJConstant.SUCCESS);
            }
        };
    },
    shareToSocietyAction: function (id, type) {
        return (dispatch, getState) => {
            // facebook分享页面：https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.flexclip.com%2F
            // twitter: https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.smartvideomaker.com%2F
            // linkin: https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fwww.smartvideomaker.com%2F
            // tumblr: https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=https%3A%2F%2Fwww.smartvideomaker.com%2F
            const { historyList } = getState().common;
            const item = historyList.find(item => item.id === id);
            const tool = FJUtil.getToolName();
            const buryData = {
                tool,
                share: type.toLowerCase(),
            };
            FJUtil.eaLog('ai tool share click', buryData);
            const shareLink = FJConfig.serverPath + `ai-share/${item.shareKey}.html`;
            const __open = url => {
                let popWidth = 600;
                let popHeight = 480;
                let left = window.innerWidth / 2 - popWidth / 2 + window.screenX;
                let top = window.innerHeight / 2 - popHeight / 2 + window.screenY;
                let popParams =
                    'scrollbars=no, width=' + popWidth + ', height=' + popHeight + ', top=' + top + ', left=' + left;
                let newWindow = window.open(url, '', popParams);

                if (window.focus) {
                    newWindow.focus();
                }
            };

            switch (type) {
                case FJConstant.FACEBOOK:
                    __open('https://www.facebook.com/sharer/sharer.php?u=' + shareLink);
                    break;
                case FJConstant.TWITTER:
                    __open('https://twitter.com/intent/tweet?url=' + shareLink);
                    break;
                case FJConstant.TUMBLR:
                    __open('https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=' + shareLink);
                    break;
                case FJConstant.COPY_LINK:
                    FJUtil.copyText(shareLink);
                    FJMessageStore.addMessage(FJLocalStore._('link-copied'));

                    break;
                default:
                    break;
            }
        };
    },

    showUploadImageAsPromptModalAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageAsPromptModalData({ display: true }));
        };
    },
    hideUploadImageAsPromptModalAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageAsPromptModalData({ display: false }));
        };
    },

    showGlobalLoadingAction: function () {
        return dispatch => {
            dispatch(setGlobalLoadingDisplay(true));
        };
    },
    hideGlobalLoadingAction: function () {
        return dispatch => {
            dispatch(setGlobalLoadingDisplay(false));
        };
    },
    showMobileSimplePreviewModalAction: function (data) {
        return dispatch => {
            dispatch(setMobileSimplePreviewData({ data, display: true }));
        };
    },
    hideMobileSimplePreviewModalAction: function () {
        return dispatch => {
            dispatch(setMobileSimplePreviewData({ display: false }));
        };
    },
    /**
     *  账号变更提示
     * @returns
     */
    accountChangesModalAction: function () {
        return dispatch => {
            dispatch(
                this.showWarningModalAction({
                    title: FJLocalStore._('account-changes'),
                    content: FJLocalStore._(
                        'the-current-account-has-been-changed-continuing-will-refresh-the-page-and-the-current-uploads-and-settings-will-not-be-retained',
                    ),
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('continue'),
                            btnCallback: async () => {
                                location.reload();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },

    showRecordModalAction: function () {
        return dispatch => {
            dispatch(FJActionRecord.initRecorderAction());
            dispatch(setSliceIsShowRecordDisplay(true));
        };
    },

    hideRecordModalAction: function () {
        return dispatch => {
            dispatch(setSliceIsShowRecordDisplay(false));
            FJActionRecord.stopPreviewRecorder();
            dispatch(FJActionRecord.stopRecorderAction(true));
        };
    },
    showAutoSelectionNoticeModalAction: function () {
        return dispatch => {
            dispatch(setAutoSelectionNoticeDisplay(true));
        };
    },
    hideAutoSelectionNoticeModalAction: function () {
        return dispatch => {
            dispatch(setAutoSelectionNoticeDisplay(false));
        };
    },
};
